import axios from 'axios';

// Get API URL from environment or use production fallback
const API_URL = process.env.REACT_APP_API_URL || 'https://quality-voice.onrender.com';

if (!process.env.REACT_APP_API_URL && process.env.NODE_ENV === 'production') {
  console.warn('⚠️ REACT_APP_API_URL not set. Using default:', API_URL);
}

export { API_URL };

export const resolveMediaUrl = (path) => {
  if (!path || typeof path !== 'string') return '';
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

const API = axios.create({
  baseURL: `${API_URL}/api`
});

// Attach JWT token to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('qv_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auth
export const signup = (data) => API.post('/auth/signup', data);
export const login = (data) => API.post('/auth/login', data);

// Users
export const getProfile = () => API.get('/users/profile');
export const getUserProfile = (id) => API.get(`/users/${id}`);
export const updateProfile = (data) => API.put('/users/profile', data);
export const searchUsers = (q) => API.get('/users/search/query', { params: { q } });
export const getSavedShops = () => API.get('/users/saved-shops/list');
export const toggleSavedShop = (shopId) => API.post(`/users/saved-shops/${shopId}`);

// Shops
export const getShops = (params) => API.get('/shops', { params });
export const getShop = (id) => API.get(`/shops/${id}`);
export const createShop = (data) => API.post('/shops', data);
export const deleteShop = (id) => API.delete(`/shops/${id}`);

// Reviews
export const getReviews = (shopId) => API.get(`/reviews/${shopId}`);
export const createReview = (data) => API.post('/reviews', data);
export const likeReview = (reviewId) => API.post(`/reviews/${reviewId}/like`);
export const markHelpful = (reviewId) => API.post(`/reviews/${reviewId}/helpful`);

// Comments
export const getComments = (reviewId) => API.get(`/comments/${reviewId}`);
export const createComment = (data) => API.post('/comments', data);
export const deleteComment = (commentId) => API.delete(`/comments/${commentId}`);

// Reports
export const createReport = (data) => API.post('/reports', data);
export const getReports = () => API.get('/reports');
export const updateReportStatus = (id) => API.put(`/reports/${id}/status`);

// Badges
export const giveBadge = (shopId) => API.post(`/badges/${shopId}`);
export const removeBadge = (shopId) => API.delete(`/badges/${shopId}`);

// Feed
export const getFeed = (params) => API.get('/feed', { params });

// Notifications
export const getNotifications = () => API.get('/notifications');
export const getUnreadCount = () => API.get('/notifications/unread-count');
export const markAllRead = () => API.put('/notifications/mark-all-read');
export const markOneRead = (id) => API.put(`/notifications/${id}/read`);

// Follow
export const checkFollow = (userId) => API.get(`/follow/check/${userId}`);
export const followUser = (userId) => API.post(`/follow/${userId}`);
export const unfollowUser = (userId) => API.post(`/follow/unfollow/${userId}`);
export const getFollowers = () => API.get('/follow/followers');
export const getFollowing = () => API.get('/follow/following');
export const getFollowSuggestions = () => API.get('/follow/suggestions');

export default API;
